class WindowLocation {
  static protocol () {
    return window.location.protocol
  }

  static port () {
    return window.location.port
  }

  static hostname () {
    return window.location.hostname
  }

  static pathname () {
    return window.location.pathname
  }

  static search () {
    return window.location.search
  }

  static subdomain () {
    return window.location.href.split('.')[0].split('/')[2]
  }

  static reload (...args) {
    window.location.reload(...args)
  }

  static replace (...args) {
    window.location.replace(...args)
  }

  static assign (...args) {
    window.location.assign(...args)
  }
}

export default WindowLocation
